<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :show-close="false"
    center
    width="60%"
    top="8vh"
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.terminalBatch.seeParames')"
      :icon="'see-title'"
      @close="closeDialog"
    />
    <el-row type="flex" justify="start">
      <el-col :span="lang == 'zh' ? 8 : 9">
        <el-form
          :label-position="'right'"
          :model="data"
          :label-width="$t('carMonitor.terminalBatch.searchWidth.width1')"
        >
          <el-form-item :label="$t('carMonitor.terminalBatch.commandName')+'：'">
            <el-input v-model="data.packetname" disabled clearable :placeholder="$t('carMonitor.terminalBatch.commandName')" />
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form :label-position="'right'" :model="data" :label-width="'80px'">
          <el-form-item :label="$t('carMonitor.terminalBatch.remark')+'：'">
            <el-input v-model="data.remark" disabled clearable />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div style="min-height:50vh">
      <el-table
        size="mini"
        :data="list"
        show-overflow-tooltip
        :max-height="tableHeight"
        :header-row-style="headerRowStyle"
        :row-style="rowStyle"
        :header-cell-style="headerCellStyle"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('table.id')" align="center" width="65">
          <template slot-scope="scope">
            <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item,index) in tableList"
          :key="index"
          :label="item.value"
          :prop="item.prop"
          :align="item.position"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
// request
import { getCommandParamById } from '@/api/carMonitor/terminalBatch'
import { tableStyle } from '@/mixins/tableStyle'
export default {
  name: 'ExamineDialog',
  mixins: [tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      listQuery: {
        pageNum: '',
        pageSize: ''
      },
      list: [],
      tableHeight: 0,
      tableList: [
        { value: this.$t('carMonitor.terminalBatch.commandName'), prop: 'commandname', position: 'center' },
        { value: this.$t('carMonitor.terminalBatch.data'), prop: 'param', position: 'center' },
        { value: this.$t('carMonitor.terminalBatch.remark'), prop: 'remark', position: 'center' }
      ]
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        const postData = {
          packetid: this.data.packetid
        }
        this.list = []
        getCommandParamById(postData).then(({ data }) => {
          if (data.code === 0) {
            this.list = data.data || []
            // this.formInfo = { ...data.data[0] }
          }
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.5
    })
    window.onresize = ()=> {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.5
      })
    }
  },
  methods: {
    // 关闭
    closeDialog() {
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    }
  }
}
</script>

<style lang='scss'>

</style>
